module.exports = __webpack_public_path__ + "img/module-thumb.a583bcc1.jpg";